module.exports = __webpack_public_path__ + "img/ปลามั้งค์.0355169d.jpg";